export default "__VITE_ASSET__BTRFAE5s__"